export const selectTournamentMatches = (state) => state.tournament.matches || []
export const selectTournamentLoading = (state) => state.tournament.isLoading
export const selectEvents = (state) => state.tournament.events || []
export const selectEditions = (state) => state.tournament.editions || []
export const selectRounds = (state) => state.tournament.rounds || []
